import React from 'react';
import { ImportItemGroupEditTemplate } from 'themes/application/import/pages';
import { observer } from 'mobx-react';
import {setCurrentView} from 'core/utils';
import {ImportItemGroupEditViewStore} from 'application/import/stores';

@setCurrentView((rootStore, componentProps) => new ImportItemGroupEditViewStore(rootStore, componentProps), 'importItemGroupEditViewStore')
@observer
class ImportItemGroupEdit extends React.Component {
    render() {
        return <ImportItemGroupEditTemplate {...this.props} />
    }
}

export default ImportItemGroupEdit;